import { render, staticRenderFns } from "./MaxUsersCountSlider.vue?vue&type=template&id=5b1d5bf6&scoped=true&"
import script from "./MaxUsersCountSlider.vue?vue&type=script&lang=js&"
export * from "./MaxUsersCountSlider.vue?vue&type=script&lang=js&"
import style0 from "./MaxUsersCountSlider.vue?vue&type=style&index=0&id=5b1d5bf6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b1d5bf6",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VSelect } from 'vuetify/lib/components/VSelect';
import { VSlider } from 'vuetify/lib/components/VSlider';
installComponents(component, {VSelect,VSlider})
